'use client';
import { useEffect, useState } from 'react';

/**
 * This hook is used to determine the app environment based on the user agent and display mode.
 * It sets the environment to either 'web-desktop', 'web-mobile', 'pwa-desktop', or 'pwa-mobile'.
 * @returns {string} The app environment.
 */
export function useAppEnvironment(): string {
  const [env, setEnv] = useState<string>('web-desktop');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    let platform = 'desktop';
    if (isIOS) platform = 'ios';
    if (isAndroid) platform = 'android';

    setEnv(`${isStandalone ? 'pwa' : 'web'}-${platform}`);
  }, []);

  return env;
}
